import Button from "../../Button";
import React, { useEffect, useState } from "react";
import Drawer from "../../CommonComponents/Drawer";
import constants from "../../../constants";
import MockTestLibraryHooks from "../../../Hooks/Mock/Student/MockTestLibraryHooks";
import useS3FileManagement from "../../../Hooks/useS3FileManagement";
import "../../../Sass/Layout/MockTestPage/Student/CompanySpecificLibrary.scss";
import Tooltip from "../../CommonComponents/Tooltip";
const base64ImageRegex =
  /^data:image\/(png|jpeg|jpg|gif|webp);base64,[A-Za-z0-9+/=]+$/;

const isDirectUrl = (value) =>
  typeof value === "string" && /^(https?:)?\/\//i.test(value);

const getImageKey = (test) => {
  const imageKey = test?.image || test?.thumbnail;

  if (
    !imageKey ||
    imageKey === "null" ||
    imageKey === "undefined" ||
    typeof imageKey !== "string"
  ) {
    return null;
  }

  return imageKey;
};

const CompanyIcon = () => (
  <svg
    width="19"
    height="20"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.41667 6.08333H2.48333C2.10996 6.08333 1.92328 6.08333 1.78067 6.156C1.65523 6.21991 1.55324 6.3219 1.48933 6.44734C1.41667 6.58995 1.41667 6.77663 1.41667 7.15V12.75M10.4167 6.08333H12.35C12.7234 6.08333 12.9101 6.08333 13.0527 6.156C13.1781 6.21991 13.2801 6.3219 13.344 6.44734C13.4167 6.58995 13.4167 6.77663 13.4167 7.15V12.75M10.4167 12.75V2.88333C10.4167 2.1366 10.4167 1.76323 10.2713 1.47801C10.1435 1.22713 9.93954 1.02316 9.68865 0.895325C9.40344 0.75 9.03007 0.75 8.28333 0.75H6.55C5.80326 0.75 5.42989 0.75 5.14468 0.895325C4.8938 1.02316 4.68982 1.22713 4.56199 1.47801C4.41667 1.76323 4.41667 2.1366 4.41667 2.88333V12.75M14.0833 12.75H0.75M6.75 3.41667H8.08333M6.75 6.08333H8.08333M6.75 8.75H8.08333"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function CompanySpecificLibraryCards(Props) {
  const MockTestLibraryHks = MockTestLibraryHooks();
  const { getPreSignedUrl } = useS3FileManagement();
  const test = Props.test;
  const imageKey = getImageKey(test);
  const [signedImageUrl, setSignedImageUrl] = useState(null);
  const [imageLoadFailed, setImageLoadFailed] = useState(false);
  const [showDetailsDrawer, setShowDetailsDrawer] = useState(false);

  const imageUrl =
    imageKey && (base64ImageRegex.test(imageKey) || isDirectUrl(imageKey))
      ? imageKey
      : signedImageUrl;

  useEffect(() => {
    let isMounted = true;

    const loadImage = async () => {
      setSignedImageUrl(null);
      setImageLoadFailed(false);

      if (!imageKey || base64ImageRegex.test(imageKey) || isDirectUrl(imageKey)) {
        return;
      }

      try {
        const res = await getPreSignedUrl([imageKey], undefined, "", "GET");
        const signedUrl = Array.isArray(res?.url) ? res.url[0] : res?.url;

        if (isMounted) {
          setSignedImageUrl(signedUrl || null);
        }
      } catch (error) {
        console.error("Company card image signing failed:", error);
        if (isMounted) {
          setImageLoadFailed(true);
        }
      }
    };

    loadImage();

    return () => {
      isMounted = false;
    };
    // getPreSignedUrl is recreated by the hook; imageKey is the intended trigger.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageKey]);

  const takeTestButtonText =
    test.status === constants.PROGRESS_STATUS.IN_PROGRESS &&
    test.libtype === constants.libTypeIds.CODING_CHALLENGE
      ? "Resume test"
      : "Take test";

  const takeTestButtonIcon =
    test.videoqn === 1 ? (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.3346 7.44277C18.3346 6.93792 18.3346 6.6855 18.2348 6.56861C18.1482 6.46719 18.0182 6.41337 17.8853 6.42383C17.732 6.43589 17.5535 6.61438 17.1966 6.97136L14.168 9.99996L17.1966 13.0286C17.5535 13.3855 17.732 13.564 17.8853 13.5761C18.0182 13.5866 18.1482 13.5327 18.2348 13.4313C18.3346 13.3144 18.3346 13.062 18.3346 12.5572V7.44277Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.66797 8.16663C1.66797 6.7665 1.66797 6.06643 1.94045 5.53165C2.18014 5.06124 2.56259 4.67879 3.03299 4.43911C3.56777 4.16663 4.26784 4.16663 5.66797 4.16663H10.168C11.5681 4.16663 12.2682 4.16663 12.8029 4.43911C13.2734 4.67879 13.6558 5.06124 13.8955 5.53165C14.168 6.06643 14.168 6.76649 14.168 8.16663V11.8333C14.168 13.2334 14.168 13.9335 13.8955 14.4683C13.6558 14.9387 13.2734 15.3211 12.8029 15.5608C12.2682 15.8333 11.5681 15.8333 10.168 15.8333H5.66797C4.26784 15.8333 3.56777 15.8333 3.03299 15.5608C2.56259 15.3211 2.18014 14.9387 1.94045 14.4683C1.66797 13.9335 1.66797 13.2334 1.66797 11.8333V8.16663Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ) : (<svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="white"
        stroke-width="1.67"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M4.16699 10.0013H15.8337M15.8337 10.0013L10.0003 4.16797M15.8337 10.0013L10.0003 15.8346"
      />
    </svg>);

  const takeTestButton = (
    <Button
      size="sm"
      onClick={() => MockTestLibraryHks.handleTest(test)}
      icon={{
        type: "trailing",
        icon: takeTestButtonIcon,
        nospace: true,
      }}
      hierarchy={{
        type: "primary",
        buttonText: takeTestButtonText,
      }}
    />
  );

  return (
    <>
      <div key={test.id} className="CompanySpecificLibraryGrid">
        <div className="CompanySpecificLibraryGridIcon">
          {imageUrl && !imageLoadFailed ? (
            <img
              src={imageUrl}
              alt={test.name || "Test thumbnail"}
              onError={() => setImageLoadFailed(true)}
            />
          ) : (
            <CompanyIcon />
          )}
        </div>

        <div className="CompanySpecificLibraryGridContent">
          <div className="CompanySpecificLibraryGridHeader">
            <div className="CompanySpecificLibraryGridHeaderTitle">
              {test.name}
            </div>
          </div>

          <div className="CompanySpecificLibraryGridSubHeader">
            <div className="CompanySpecificLibraryGridSubHeaderTestTitle">
              {MockTestLibraryHks.getTestType(test)} • {test.questionscount}{" "}
              Questions • {MockTestLibraryHks.getTime(test.testduration)}
            </div>
          </div>
          <Tooltip title={test.description} position="top" maxChars={300} theme="light">
          <div className="CompanySpecificLibraryGridTestDescription">
            {test.description}
          </div>
          </Tooltip>

          <div className="CompanySpecificLibraryGridTestTagsDiv">
            {test.tags &&
              test.tags !== "" &&
              test.tags !== null &&
              test.tags !== "null" && (
                <div className="CompanySpecificLibraryGridTestTags">
                  {test.tags}
                </div>
              )}
          </div>
        </div>

        <div className="CompanySpecificLibraryGridFooter">
          <Button
            size="sm"
            onClick={() => setShowDetailsDrawer(true)}
            hierarchy={{
              type: "linkColor",
              buttonText: "View Details",
            }}
          />
          <Button
            size="sm"
            onClick={() => MockTestLibraryHks.handleTest(test)}
            icon={{
              type: "trailing",
              icon: takeTestButtonIcon,
              nospace: true,
            }}
            hierarchy={{
              type: "primary",
              buttonText: takeTestButtonText,
            }}
          />
        </div>
      </div>

      <Drawer
        open={showDetailsDrawer}
        onClose={() => setShowDetailsDrawer(false)}
        anchor="right"
        title={test.name || "Test Details"}
        width={"50%"}
        className="CompanySpecificLibraryDetailsDrawer"
      >
        <div className="CompanySpecificLibraryDetailsDrawerBox">
          {test.instruction ? (
            <div
              className="CompanySpecificLibraryDetailsDrawerInstruction"
              dangerouslySetInnerHTML={{ __html: test.instruction }}
            />
          ) : (
            <p className="CompanySpecificLibraryDetailsDrawerEmpty">
              No instructions available.
            </p>
          )}
        </div>
      </Drawer>
    </>
  );
}
